var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"app-avatar",class:{ 'app-avatar--40': _vm.px >= 40, 'app-avatar--ring': _vm.ring },style:(_vm.sizeStyle),attrs:{"aria-hidden":"true"}},[_vm._v(_vm._s(_vm.initials))])}
var staticRenderFns = []

export { render, staticRenderFns }